// extracted by mini-css-extract-plugin
export var checkbox = "_12-0";
export var circle = "_12-3";
export var horizontalContainer = "_12-7";
export var sm = "_12-5";
export var switch0 = "_12-2";
export var switchDisabled = "_12-8";
export var switchEnabled = "_12-1";
export var textSwitchContainer = "_12-9";
export var textSwitchOption = "_12-a";
export var textSwitchOptionSelected = "_12-b";
export var verticalContainer = "_12-6";
export var xs = "_12-4";